var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMonitorMobbile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21 17.7c-3.8 0-4.96-1.16-4.96-4.96v-6c0-3.8 1.16-4.96 4.96-4.96h10.53c3.8 0 4.96 1.16 4.96 4.96 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-2.94-.52-3.46-3.46-3.46H6.21c-2.94 0-3.46.52-3.46 3.46v6c0 2.94.52 3.46 3.46 3.46H10c.41 0 .75.34.75.75s-.34.75-.75.75H6.21z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 21.47v-4.53c0-.41.34-.75.75-.75s.75.34.75.75v4.53a.749.749 0 1 1-1.5 0zM2 13.7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74 22.22c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H10c.41 0 .75.34.75.75s-.34.75-.75.75H6.74z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.49 22.22c-2.77 0-3.71-.94-3.71-3.71V12.8c0-2.77.94-3.71 3.71-3.71h3.55c2.77 0 3.71.94 3.71 3.71v5.71c0 2.78-.94 3.71-3.71 3.71h-3.55zm-2.21-9.42v5.71c0 1.96.25 2.21 2.21 2.21h3.55c1.96 0 2.21-.25 2.21-2.21V12.8c0-1.96-.25-2.21-2.21-2.21h-3.55c-1.96 0-2.21.25-2.21 2.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.59 18.68a.988.988 0 0 1-.21-.32c-.05-.13-.08-.26-.08-.39 0-.26.11-.52.29-.7.23-.23.58-.34.91-.28l.18.06c.06.03.12.06.17.09a1.009 1.009 0 0 1 .45.83c0 .13-.03.26-.08.39-.05.12-.12.23-.21.32a.61.61 0 0 1-.16.12.95.95 0 0 1-.17.1c-.06.02-.12.04-.18.05-.07.02-.13.02-.2.02-.26 0-.52-.1-.71-.29z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMonitorMobbile);
export default __webpack_public_path__ + "static/media/vuesax-outline-monitor-mobbile.69152262389101aef01dbb60bf12750e.svg";
export { ForwardRef as ReactComponent };